import {
    Acl,
    ShareBaseFolder,
	ShareBaseDocument
} from 'phoenix/domain';
import { IShareableStore } from 'sharebase/domain';
import { 
    ShareTab,
    ShareDialogController 
} from 'sharebase/components/shareDialog/shareDialog';

export interface IShareDialogService {
    show(event: ng.IAngularEvent, context: ShareBaseDocument | ShareBaseFolder, store:IShareableStore, targetStep: ShareTab, targetShareList: number, share?: Acl):void;
}

const dialogTemplateUrl = require('sharebase/components/shareDialog/shareDialog.template');
export function ShareDialogServiceFactory($mdDialog, $mdMedia) {
    var service = {
        show
    };

    return service;

    function show(event: ng.IAngularEvent, context: ShareBaseDocument | ShareBaseFolder, store:IShareableStore, targetStep: ShareTab, targetShareList: number, share: Acl = null) {
        var config = {
            controller: ShareDialogController,
            template: dialogTemplateUrl,
            controllerAs:'vm',
            targetEvent: event,
            fullscreen: $mdMedia('sm') || $mdMedia('xs'),
            clickOutsideToClose: true,
            locals: {
                context: context,
                aclToEdit: share,
                datastore: store,
                targetStep,
                targetShareList
            }
        };

        $mdDialog.show(config);
    }
}

ShareDialogServiceFactory.$inject = [
    '$mdDialog', 
    '$mdMedia'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/services/shareDialogService.ts